export const DIMMING_ICON = "<i class='fa fc fc-series-dim'></i>";
